import { useLang } from "@/context/LanguageContext";
import { VIDEO } from "@/data/content";
import { Reveal } from "./anim";

export default function Intro() {
  const { t } = useLang();
  const c = t.intro;

  return (
    <section className="relative py-24 md:py-36 bg-cream" data-testid="intro-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-[1fr_auto] gap-12 lg:gap-24 items-center">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-brand mb-6">{c.overline}</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.1] tracking-tight text-ink max-w-xl">
            {c.title}
          </h2>
          <p className="mt-6 font-light text-base sm:text-lg leading-relaxed text-ink-soft max-w-lg">
            {c.text}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative w-full lg:w-[380px] mx-auto rounded-tl-[3rem] rounded-br-[3rem] overflow-hidden shadow-[0_20px_60px_rgba(45,42,38,0.15)]">
            <video
              data-testid="intro-video"
              className="w-full h-auto object-cover"
              autoPlay
              muted
              loop
              playsInline
              poster={VIDEO.poster}
            >
              <source src={VIDEO.webm} type="video/webm" />
              <source src={VIDEO.mp4} type="video/mp4" />
            </video>
            <div className="absolute bottom-4 left-4 inline-flex items-center gap-2 bg-cream/20 backdrop-blur-md text-cream text-[0.65rem] tracking-[0.15em] uppercase px-3 py-1.5 rounded-full">
              <span className="w-2 h-2 rounded-full bg-whatsapp animate-pulse" />
              {c.videoTag}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
